import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;
const slug = "api";

const ExpenseCategoryServices = {
  create: async (data) => {
    const response = await apiService.post(`/${slug}/category/createcategory`, data);
    return response.data;
  },
  getList: async () => {
    const response = await apiService.get(`/${slug}/category/getallcategory`);
    return response.data;
  },
  detail: async (id) => {
    const response = await apiService.get(`/${slug}/purchase/${id}`);
    return response.data;
  },
  update: async (id, data) => {
    const response = await apiService.put(`/${slug}/category/update/${id}`, data);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/${slug}/category/delete/${id}`);
    return response.data;
  },
};

export default ExpenseCategoryServices;
